import React from "react"

import {FieldPickerProps} from "../../../../render/picker"
import HintPopover from "../../../../../gd-ui/hint-popover/hint-popover"
import FieldTimeReported from "../time-spent";
import TimeReport from "../../../../../model2/time-report/time-report";

type Props = FieldPickerProps & {
    field: FieldTimeReported
}

const debug = false
// const debug = "FieldTimeReported_Picker"

export default class FieldTimeSpent_Picker extends React.Component<Props,any> {

    constructor(props:Props) {
        super(props);

        debug && console.log(debug,"constructor", props)

        const jsonData      = this.props.model.toJSON()
        const timeReport    = new TimeReport(_.assign({}, jsonData, {
                'reportedTimeMinutes'   : jsonData[this.props.field.fieldId],
                'startMoment'           : jsonData[this.props.field.startMomentFieldId],
                'endMoment'             : jsonData[this.props.field.endMomentFieldId],
            }))

        this.state = {
            timeReport  : timeReport,
            showPopover : false,
        }
    }

    showPopover = () => {
        if (!this.state.showPopover) this.setState({showPopover: true})
    }

    hidePopover = () => {
        if (this.state.showPopover) this.setState({showPopover: false})
    }

    _onChange = () => {
        if (this.props.onChange) {
            this.props.onChange(
                this.state.timeReport.reportedTimeMinutes,
                this.state.timeReport.startMoment,
                this.state.timeReport.endMoment,
                this.state.timeReport
            )
        }
    }

    onValueChange = (value:any, commitChange: boolean = false) => {
        debug && console.log(debug, 'onValueChange', value, commitChange)

        this.state.timeReport.reportedTimeMinutes = value

        this.setState({
            timeReport: new TimeReport(this.state.timeReport.toJSON())
        }, () => {
            this._onChange()
            commitChange && this.hidePopover()
        })
    }

    onIsBillableChange = (isBillable:boolean) => {
        debug && console.log(debug, 'onIsBillableChange', isBillable)

        if (!_.isUndefined(isBillable)) {
            this.state.timeReport.isBillable = isBillable
            debug && console.log(debug, 'onIsBillableChange isBillable=', isBillable, this.state.timeReport.isBillable)
        }

        this.setState({
            timeReport: new TimeReport(this.state.timeReport.toJSON())
        }, () => {
            this._onChange()
        })
    }

    onTimeChange = (startMoment?: Moment, endMoment?:Moment) => {
        debug && console.log(debug, 'onTimeChange', startMoment, endMoment)

        if (!_.isUndefined(startMoment)) {
            this.state.timeReport.startMoment = startMoment
            debug && console.log(debug, 'onTimeChange startMoment', startMoment, this.state.timeReport.startMoment)
        }
        if (!_.isUndefined(endMoment)) {
            this.state.timeReport.endMoment = endMoment
            debug && console.log(debug, 'onTimeChange endMoment', endMoment, this.state.timeReport.endMoment)
        }

        this.setState({
            timeReport: new TimeReport(this.state.timeReport.toJSON())
        }, () => {
            this._onChange()
        })
    }

    render() {

        const {field} = this.props;

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        });

        debug && console.log(debug, 'render', this.state.timeReport)

        if (this.state.timeReport.reportedTimeMinutes) {
            return (
                <field.components.PickerValueNotEmpty className = {classes}
                                                      field     = {this.props.field}
                                                      value     = {this.state.timeReport.reportedTimeMinutes}
                                                      options   = {this.props.options}
                                                      onClick   = {this.showPopover}
                                                      onChange  = {this.onValueChange}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} model={this.state.timeReport}/>}
                    {/*{!this.state.showPopover && <HintPopover hint={this.props.field.label}/>}*/}
                </field.components.PickerValueNotEmpty>
            );
        } else {
            return (
                <field.components.PickerValueEmpty className={classes} field={this.props.field} onClick={this.showPopover} options={this.props.options}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} model={this.state.timeReport}/>}
                    {!this.state.showPopover && <HintPopover hint="Add time report" />}
                </field.components.PickerValueEmpty>
            );
        }
    }
}


